import PropTypes from 'prop-types';

import { Filter } from 'basic-components/icons';

const EMPTY_OBJ = {};

const DropdownIndicator = ({ innerProps = EMPTY_OBJ }) => (
  <div
      {...innerProps}
      className="ng-dropdown__component__indicators__indicator"
  >
    <Filter
        color="blue-bright"
        height={12}
        width={12}
    />
  </div>
)

DropdownIndicator.propTypes = {
  innerProps: PropTypes.object,
  selectProps: PropTypes.object
}

export default DropdownIndicator;